const PROPERTIES_LOCALE = {
  'en-gb': {
    2: 'Hotel',
    7: 'Villa',
    21: 'Resort',
    9: 'Apartment',
    35: 'Guesthouse',
    48: 'Hostel',
    54: 'Motel',
    8: 'Lodge',
    3: 'Chalet',
    34: 'Bed & breakfast',
  },
  'id-id': {
    2: 'Hotel',
    7: 'Villa',
    21: 'Resort',
    9: 'Apartemen',
    35: 'Guest house',
    48: 'Hostel',
    54: 'Motel',
    8: 'Pondok',
    3: 'Chalet',
    34: 'Bed & breakfast',
  },
  'ja-jp': {
    2: 'ホテル',
    7: 'ヴィラ',
    21: 'リゾート',
    9: 'アパートメント',
    35: 'ゲストハウス',
    48: 'ホステル',
    54: 'モーテル',
    8: 'ロッジ',
    3: 'シャレー',
    34: '朝食付き安宿',
  },
  'ko-kr': {
    2: '호텔',
    7: '빌라',
    21: '리조트',
    9: '아파트',
    35: '게스트하우스',
    48: '호스텔',
    54: '모텔',
    8: '산장',
    3: '샬레',
    34: '베드앤브랙퍼스트',
  },
  'ms-my': {
    2: 'Hotel',
    7: 'Vila',
    21: 'Tempat peranginan',
    9: 'Pangsapuri',
    35: 'Rumah tetamu',
    48: 'Asrama',
    54: 'Motel',
    8: 'Rumah persinggahan',
    3: 'Chalet',
    34: 'Penginapan dan sarapan',
  },
  'th-th': {
    2: 'โรงแรม',
    7: 'วิลล่า',
    21: 'รีสอร์ท',
    9: 'อพาร์ทเมนท์',
    35: 'เกสต์เฮ้าส์',
    48: 'โฮสเทล',
    54: 'โมเต็ล',
    8: 'ลอดจ์',
    3: 'ชาเลต์',
    34: 'เบด แอนด์ เบรกฟาสต์',
  },
  'vi-vn': {
    2: 'Khách sạn',
    7: 'Biệt thự',
    21: 'Biệt thự nghỉ dưỡng',
    9: 'Căn hộ',
    35: 'Nhà khách',
    48: 'Nhà nghỉ tập thể',
    54: 'Nhà nghỉ',
    8: 'Nhà nhỏ',
    3: 'Căn nhà biệt lập',
    34: 'Phòng kèm bữa sáng',
  },
  'zh-cn': {
    2: '酒店',
    7: '别墅',
    21: '度假村',
    9: '公寓',
    35: '招待所',
    48: '小旅馆',
    54: '汽车旅馆',
    8: '小屋',
    3: '木屋',
    34: '床&早餐',
  },
  'zh-hk': {
    2: '酒店',
    7: '別墅',
    21: '渡假村',
    9: '公寓',
    35: '招待賓館',
    48: '青年旅館',
    54: '汽車旅館',
    8: '小屋',
    3: '渡假木屋',
    34: '床位與早餐',
  },
  'zh-tw': {
    2: '飯店',
    7: '別墅',
    21: '度假村',
    9: '公寓',
    35: '短租民宿',
    48: '旅社',
    54: '汽車旅館',
    8: '木屋',
    3: '小木屋',
    34: '民宿',
  },
};

export default PROPERTIES_LOCALE;
